import StoryblokClient from "storyblok-js-client";
export var storyblok = new StoryblokClient({
  accessToken: process.env.STORYBLOK_API_KEY,
  cache: {
    clear: "auto",
    type: "memory"
  }
});
//# sourceMappingURL=storyblok.js.map